import { Maybe } from 'generated/graphql'

export const isLead = (material?: Maybe<string>): boolean => {
  if (!material) {
    return false
  }
  return 'Lead' === material
}

export const isUnknown = (material?: Maybe<string>): boolean => {
  if (!material) {
    return true
  }
  return 'Lead Status Unknown' === material
}

export const isNonLead = (material?: Maybe<string>): boolean => {
  if (!material) {
    return false
  }
  return 'Non-lead' === material
}

export const isGRR = (material?: Maybe<string>): boolean => {
  if (!material) {
    return false
  }
  return 'Galvanized Requiring Replacement' === material
}

// Icons
const ICON_PATHS = {
  CHECK: `M173.898 439.404l-166.4-166.4c-9.997-9.997-9.997-26.206 0-36.204l36.203-36.204c9.997-9.998 26.207-9.998 36.204 0L192 312.69 432.095 72.596c9.997-9.997 26.207-9.997 36.204 0l36.203 36.204c9.997 9.997 9.997 26.206 0 36.204l-294.4 294.401c-9.998 9.997-26.207 9.997-36.204-.001z`,
  EXCLAMATION: `M176 432c0 44.112-35.888 80-80 80s-80-35.888-80-80 35.888-80 80-80 80 35.888 80 80zM25.26 25.199l13.6 272C39.499 309.972 50.041 320 62.83 320h66.34c12.789 0 23.331-10.028 23.97-22.801l13.6-272C167.425 11.49 156.496 0 142.77 0H49.23C35.504 0 24.575 11.49 25.26 25.199z`,
  QUESTION: `M202.021 0C122.202 0 70.503 32.703 29.914 91.026c-7.363 10.58-5.093 25.086 5.178 32.874l43.138 32.709c10.373 7.865 25.132 6.026 33.253-4.148 25.049-31.381 43.63-49.449 82.757-49.449 30.764 0 68.816 19.799 68.816 49.631 0 22.552-18.617 34.134-48.993 51.164-35.423 19.86-82.299 44.576-82.299 106.405V320c0 13.255 10.745 24 24 24h72.471c13.255 0 24-10.745 24-24v-5.773c0-42.86 125.268-44.645 125.268-160.627C377.504 66.256 286.902 0 202.021 0zM192 373.459c-38.196 0-69.271 31.075-69.271 69.271 0 38.195 31.075 69.27 69.271 69.27s69.271-31.075 69.271-69.271-31.075-69.27-69.271-69.27z`
}

const ICON_LEAD = ICON_PATHS.EXCLAMATION
const ICON_NO_LEAD = ICON_PATHS.CHECK
const ICON_UNKNOWN = ICON_PATHS.QUESTION

export const serviceLineMaterialIcon = (
  displayValue?: Maybe<string>
): string => {
  switch (displayValue) {
    case 'Galvanized Requiring Replacement':
    case 'Lead':
      return ICON_LEAD
    case 'Non-lead':
      return ICON_NO_LEAD
    case 'Lead Status Unknown':
    default:
      return ICON_UNKNOWN
  }
}

export const serviceLineMaterialColor = (material?: Maybe<string>): string => {
  if (!material) return '#0033A0'
  if (isLead(material)) return '#F7685B'
  if (isGRR(material)) return '#FFC72C'
  if (isNonLead(material)) return '#00B5E2'
  return '#0033A0'
}

export const serviceLineMaterialBadgeColor = (
  color?: Maybe<string>
): undefined | string => {
  return color?.toString()
}
